<template>
  <van-popup
    v-model="visible"
    position="bottom"
    round
    :close-on-click-overlay="true"
    class="create-sub-match-popup"
    @closed="onClosed"
  >
    <div class="popup-header">
      <div class="popup-title">创建比赛</div>
      <div class="popup-close" @click="close">
        <van-icon name="cross" size="16" color="#fff" />
      </div>
    </div>

    <div class="match-picker">
      <wheel-battle-match-picker
        :home-team="homeTeam"
        :away-team="awayTeam"
        :match-logo="matchLogo"
        home-placeholder="请选择"
        away-placeholder="请选择"
        clickable
        @click-home="openTeamPicker('home')"
        @click-away="openTeamPicker('away')"
      />
    </div>

    <div class="popup-footer">
      <van-button
        type="primary"
        round
        class="submit-btn"
        :loading="submitting"
        @click="onSubmit"
      >
        提交
      </van-button>
    </div>

    <van-popup v-model="showTeamPicker" position="bottom" round>
      <van-picker
        show-toolbar
        title="选择球队"
        value-key="name"
        :columns="teamPickerColumns"
        @confirm="onTeamConfirm"
        @cancel="showTeamPicker = false"
      />
    </van-popup>
  </van-popup>
</template>

<script>
import Vue from 'vue'
import { Popup, Icon, Button, Picker, Toast } from 'vant'
Vue.use(Popup).use(Icon).use(Picker).use(Button).use(Toast)

import WheelBattleMatchPicker from './WheelBattleMatchPicker.vue'

export default {
  name: 'WheelBattleCreateSubMatchPopup',
  components: {
    WheelBattleMatchPicker
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    teams: {
      type: Array,
      default: function () {
        return []
      }
    },
    matchLogo: {
      type: String,
      default: ''
    },
    defaultHomeId: {
      type: String,
      default: ''
    },
    defaultAwayId: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      submitting: false,
      showTeamPicker: false,
      pickerSide: 'home',
      homeTeam: {},
      awayTeam: {}
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('input', val)
      }
    },
    teamPickerColumns: function () {
      var otherId = this.pickerSide === 'home'
        ? (this.awayTeam && this.awayTeam.id)
        : (this.homeTeam && this.homeTeam.id)
      return (this.teams || []).filter(function (team) {
        return team.id !== otherId
      })
    }
  },
  watch: {
    value: function (show) {
      if (show) {
        this.initTeams()
      }
    }
  },
  methods: {
    findTeamById: function (id) {
      var list = this.teams || []
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === id) {
          return Object.assign({}, list[i])
        }
      }
      return null
    },
    initTeams: function () {
      var list = this.teams || []
      var home = this.findTeamById(this.defaultHomeId) || (list[0] ? Object.assign({}, list[0]) : {})
      var away = this.findTeamById(this.defaultAwayId) || (list[1] ? Object.assign({}, list[1]) : {})
      if (home.id && away.id && home.id === away.id && list[1]) {
        away = Object.assign({}, list[1])
      }
      this.homeTeam = home
      this.awayTeam = away
    },
    openTeamPicker: function (side) {
      if (!this.teams.length) {
        Toast('请先设置出赛球队')
        return
      }
      this.pickerSide = side
      this.showTeamPicker = true
    },
    onTeamConfirm: function (team) {
      this.showTeamPicker = false
      if (!team) {
        return
      }
      if (this.pickerSide === 'home') {
        this.homeTeam = Object.assign({}, team)
      } else {
        this.awayTeam = Object.assign({}, team)
      }
    },
    close: function () {
      this.visible = false
    },
    onClosed: function () {
      this.submitting = false
    },
    onSubmit: function () {
      if (!this.homeTeam.id || !this.awayTeam.id) {
        Toast('请选择对阵球队')
        return
      }
      if (this.homeTeam.id === this.awayTeam.id) {
        Toast('主客队不能相同')
        return
      }
      this.$emit('submit', {
        homeTeam: Object.assign({}, this.homeTeam),
        awayTeam: Object.assign({}, this.awayTeam)
      })
    },
    setSubmitting: function (val) {
      this.submitting = val
    }
  }
}
</script>

<style scoped lang="scss">
.create-sub-match-popup {
  background: #fff;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}

.popup-close {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.match-picker {
  margin: 0px 10px;
  margin-block: 32px;
  padding: 0;
}

.popup-footer {
  padding: 0 16px 16px;
  display: flex;
  justify-content: flex-end;
}

.submit-btn {
  min-width: 120px;
  height: 40px;
  background: #6699cc;
  border-color: #6699cc;
}
</style>
